import React from 'react';
import { useTranslations } from 'next-intl';
import { classNames } from '@/shared/lib/classnames/classnames';
import { Button } from '@/shared/ui/button';
import btnIcons from '@/shared/assets/sprites/btns.sprite.svg';
import type { ShowPhonePreviewProps } from '../model/types';
export const PhoneNumberPreview: React.FC<ShowPhonePreviewProps> = ({
  phoneNumber,
  hasOnline,
  btnVariants,
  isFull = false,
  onShowPhoneClick,
  className,
  isIcon = false
}) => {
  const previewDigits = phoneNumber ? phoneNumber.replace(/\D/g, '').slice(0, 4) : '';
  const firstDigit = previewDigits.charAt(0);
  const t = useTranslations();
  function getSize() {
    if (isIcon) return 'icon';
    return btnVariants?.size ?? 'icon';
  }
  const getVariant = () => {
    if (isIcon) return 'secondary';
    return 'text';
  };
  return <Button size={getSize()} variant={getVariant()} textWeight={btnVariants?.textWeight ?? 'bold'} className={classNames('bg-linear-to-t flex touch-pan-y items-center gap-2 from-cyan-500 to-blue-500 hover:no-underline', {
    'mt-2': hasOnline,
    'w-full': isFull,
    'mt-0': isIcon
  }, [className])} onClick={onShowPhoneClick} aria-label={t('shared.aria.show_full_phone')} data-sentry-element="Button" data-sentry-component="PhoneNumberPreview" data-sentry-source-file="PhoneNumberPreview.tsx">
      {isIcon ? <svg className="size-6 stroke-primary stroke-1.5">
          <use xlinkHref={`${btnIcons}#phone`}></use>
        </svg> : <>
          <div className="relative">
            <span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-white"></span>
            <span className="text-sm font-normal">{`+${firstDigit} ${previewDigits.slice(1)}`}</span>
          </div>
          <span className="text-sm font-normal text-additionalBlue">{t('search.card.phone')}</span>
        </>}
    </Button>;
};